import {
	// faClipboardList,
	// faCreditCard,
	faInfoCircle,
	faPhoneAlt,
	// faRestroom,
	faShareAlt,
	faTags,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	Col,
	Row,
	Card,
	Nav,
	Tab,
	Button,
	Alert,
} from "@themesberg/react-bootstrap";
import { useContext, useEffect, useState } from "react";
import {
	PROPERTY_REDUCER_CREATE_PROPERTY,
	PROPERTY_REDUCER_UPDATE_PROPERTY,
} from "src/app/common/constants";
import { PropertyContext } from "src/app/contexts/PropertyContext";
import BasicDataInput from "./property-input/BasicDataInput";
import ContactInfoInput from "./property-input/ContactInfoInput";
//import ItineraryDataInput from "./property-input/ItineraryDataInput";
// import PaymentTypeInput from "./property-input/PaymentTypeInput";
// import RoomConfigInput from "./property-input/RoomConfigInput";
import SocialLinksInput from "./property-input/SocialLinksInput";
import { useNavigate, useLocation } from "react-router-dom";
import { LoadingContext } from "src/app/contexts/LoadingContext";
import { routesPath } from "src/app/routes";
import { v4 as uuidv4 } from "uuid";
import { verifyPropertyData } from "./verifyPropertyData";
import { AuthContext } from "src/app/contexts/AuthContext";
import OthersDataInput from "./property-input/OthersDataInput";

const AddEditProperty = () => {
	const { authData } = useContext(AuthContext);
	const { loadingData, setLoadingData } = useContext(LoadingContext);
	const [loadingId, setLoadingId] = useState(null);

	const navigateTo = useNavigate();
	const {
		propertyTypeData,
		districtsData,
		categoryData,
		setPropertyDataDispatch,
		getAllCategoriesFromContext,
	} = useContext(PropertyContext);
	const [currentTab, setCurrentTab] = useState(0);
	const [localPropertyData, setlocalPropertyData] = useState({
		name: "",
		email: "",
		description: "",
		website: "",
		phone: [],
		socials: [{}],
		video_link: "",
		external_links: [{}],
		address: "",
		area: "",
		post_code: "",
		room_config: [{}],
		itins: {
			check_in: "12:00 PM",
			check_out: "11:00 AM",
			child_max_age: "5",
		},
		payment_info: [{ name: "Cash", method: "cash" }],
		price: null,
		price_low: 300,
		price_high: 40000,
		price_type: "",
		head_image: null,
		images: {
			head_image: "",
			side_image: [""],
		},
		district_id: 0,
		property_type_id: 0,
		owner_id: 1,
		categories: [],
		search_score: 0,
		map_link: "",
	});
	const inputTabsDetails = [
		{
			icon: faInfoCircle,
			name: "Basic",
			key: "basic",
			component: BasicDataInput,
			props: {
				propertyTypeData,
				districtsData,
				categoryData,
				localPropertyData,
				setlocalPropertyData,
			},
		},
		{
			icon: faPhoneAlt,
			name: "Contacts",
			key: "contact",
			component: ContactInfoInput,
			props: { localPropertyData, setlocalPropertyData },
		},
		{
			icon: faShareAlt,
			name: "Links",
			key: "social",
			component: SocialLinksInput,
			props: { localPropertyData, setlocalPropertyData },
		},
		// {
		// 	icon: faRestroom,
		// 	name: "Rooms",
		// 	key: "room",
		// 	component: RoomConfigInput,
		// 	props: { localPropertyData, setlocalPropertyData },
		// },
		// {
		// 	icon: faClipboardList,
		// 	name: "Itineraries",
		// 	key: "itins",
		// 	component: ItineraryDataInput,
		// 	props: { localPropertyData, setlocalPropertyData },
		// },
		// {
		// 	icon: faCreditCard,
		// 	name: "Payment",
		// 	key: "payment",
		// 	component: PaymentTypeInput,
		// 	props: { localPropertyData, setlocalPropertyData },
		// },
		{
			icon: faTags,
			name: "Others",
			key: "others",
			component: OthersDataInput,
			props: { categoryData, localPropertyData, setlocalPropertyData },
		},
	];

	const [verificationErrors, setVerificationErrors] = useState([]);

	const editPageData = useLocation().state;

	const handleNextOrSubmitButton = () => {
		if (currentTab === inputTabsDetails.length - 1) {
			const verificationResult = verifyPropertyData(localPropertyData);

			console.log(verificationResult);

			if (verificationResult?.length > 0) {
				setVerificationErrors(verificationResult);
			} else {
				setVerificationErrors([]);
				let id = uuidv4();
				setLoadingId(id);
				console.log("loading ID in AddEditProperty: ", id);
				let external_links = localPropertyData?.external_links;
				if (external_links?.length) {
					external_links = external_links?.filter(
						(link) => link && link?.name && link?.link && link?.price
					);
				}
				let social_links = localPropertyData?.social_links;
				if (social_links?.length) {
					social_links = social_links?.filter(
						(link) => link && link?.name && link?.link
					);
				}

				if (editPageData) {
					setPropertyDataDispatch({
						type: PROPERTY_REDUCER_UPDATE_PROPERTY,
						data: {
							...localPropertyData,
							owner_id: authData?.user_data?.id,
							price: null,
							categories: localPropertyData?.categories?.map(
								(category) => +category.id
							),
							socials: social_links,
							external_links,
						},
						loading_id: id,
						loading: true,
						loading_message: "Updating property...",
					});
				} else {
					// Empty object of external_links is causing problems in database as it is saved as an empty array [ [] ]
					setPropertyDataDispatch({
						type: PROPERTY_REDUCER_CREATE_PROPERTY,
						data: {
							...localPropertyData,
							owner_id: authData?.user_data?.id,
							price: null,
							categories: localPropertyData?.categories?.map(
								(category) => +category.id
							),
							external_links,
							socials: social_links,
						},
						loading_id: id,
						loading: true,
						loading_message: "Creating property...",
					});
				}
			}
		} else {
			setCurrentTab(currentTab + 1);
		}
	};

	useEffect(() => {
		if (editPageData) {
			if (!editPageData?.price_low || !editPageData?.price_high) {
				editPageData.price_low = editPageData?.price;
				editPageData.price_high = editPageData?.price;
			}
			let externalLinks = editPageData?.external_links;
			let socials = editPageData?.socials;
			if (!Array.isArray(externalLinks) || externalLinks?.length === 0) {
				externalLinks = [{}];
			}
			if (!Array.isArray(socials) || socials?.length === 0) {
				socials = [{}];
			}
			setlocalPropertyData({
				...editPageData,
				external_links: externalLinks,
				socials,
			});
		}
	}, [editPageData]);

	useEffect(() => {
		console.log("loading data in add compo: ", loadingData);
		if (
			loadingData &&
			loadingId === loadingData.id &&
			loadingData.is_loading === false &&
			loadingData.is_success === true
		) {
			console.log("loading data in add compo: ", loadingData);
			navigateTo(routesPath.Properties.path);
		}
	}, [loadingData]);

	useEffect(() => {
		getAllCategoriesFromContext();
	}, []);

	return (
		<div className="justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
			{verificationErrors.length > 0 && (
				<Alert variant="danger">
					<ul>
						{verificationErrors?.map((error) => (
							<li>{error?.message}</li>
						))}
					</ul>
				</Alert>
			)}

			<Card border="light" className="shadow-sm w-100">
				<Card.Body>
					<Tab.Container
						id="property-input-tabs"
						activeKey={currentTab}
						onSelect={(k) => setCurrentTab(parseInt(k))}
					>
						<Row>
							<Col lg={12}>
								<Nav className="nav-tabs">
									{inputTabsDetails.map((tabDetails, index) => (
										<Nav.Item key={tabDetails.key}>
											<Nav.Link eventKey={index} className="mb-sm-3 mb-md-0">
												<FontAwesomeIcon
													icon={tabDetails.icon}
													className="me-2"
												/>
												{tabDetails.name}
											</Nav.Link>
										</Nav.Item>
									))}
								</Nav>
							</Col>
							<Col lg={12}>
								<Tab.Content>
									{inputTabsDetails.map((tabDetails, index) => (
										<Tab.Pane
											eventKey={index}
											className="py-4"
											key={tabDetails.key}
										>
											{tabDetails.component && (
												<tabDetails.component {...tabDetails.props} />
											)}
										</Tab.Pane>
									))}
								</Tab.Content>
							</Col>
						</Row>
						<Row>
							<Col lg={12}>
								<div className="mx-5 text-end">
									<Button
										variant="dark"
										className="m-1"
										onClick={() => handleNextOrSubmitButton()}
									>
										{currentTab === inputTabsDetails.length - 1
											? "Submit"
											: "Next"}
									</Button>
								</div>
							</Col>
						</Row>
					</Tab.Container>
				</Card.Body>
			</Card>
		</div>
	);
};

export default AddEditProperty;
